import React from 'react';
import { Link } from 'react-router-dom';
import { SeeIt } from '../components/SeeIt';
import { Faq } from '../components/Faq';
import { CtaBand } from '../components/CtaBand';
import { Ledger } from '../components/Ledger';
import { ChunkVsAtom } from '../components/how/ChunkVsAtom';
import { ConstitutionalFlow } from '../components/how/ConstitutionalFlow';
import { ReworkChart } from '../components/how/ReworkChart';
import { ReceiptCard } from '../components/how/ReceiptCard';
import { AgentChain } from '../components/how/AgentChain';
import { faqsHow } from '../data/faqsHow';
const ENGINES = [{
  stage: 'Harvest',
  n: '01 · Atomizer',
  title: 'Atomizer.',
  body: <>
        The written rules — FDA, HIPAA, FINRA, your brand book — and the moments nobody writes down become binary
        DO/DON'T atoms: owned, versioned, ready to fire.
      </>
}, {
  stage: 'Seat',
  n: '02 · Composer',
  title: 'Composer.',
  body: <>
        Fire the musts by trigger — off the top of the budget. Then hand retrieval a governed vocabulary, so RAG
        searches for what the rules mean, not what the prompt resembles.
      </>
}, {
  stage: 'Ship',
  n: '03 · Compiler',
  title: 'Compiler.',
  body: <>
        Assemble the payload in the model's own language, and sign the receipt: which obligations fired, which
        versions, on what trigger.
      </>
}];
export function How() {
  return <>
      <header className="hero" data-id="element-465" data-mp="2u5k638oy3jqm">
        <div className="hgrid wide-r" data-id="element-466" data-mp="2u4iik4qqt4s0">
          <div className="col-l" data-id="element-467" data-mp="2u7o8tnb3ycpb">
            <div className="lab-row" data-id="element-468" data-mp="2fhh0w1iq8c2v">
              <span className="clabel" data-id="element-469" data-mp="2fge81o1ufzkb">How it works</span>
            </div>
            <div className="head-block" data-id="element-470" data-mp="2keyzaxz4b8wm">
              <h1 style={{
              fontSize: 'clamp(28px,3.3vw,40px)',
              maxWidth: 'none'
            }} data-id="element-471" data-mp="2kdxmanyjkcc9">
                From a simple request
                <br data-id="element-472" data-mp="3cw1ke8916csg" />
                to the instructions
                <br data-id="element-473" data-mp="3cxw9lyrc4r2c" />
                it requires.
              </h1>
            </div>
            <div className="sub-block" data-id="element-474" data-mp="3mr0hqrei18ii">
              <p className="sub" style={{
              marginBottom: 16
            }} data-id="element-475" data-mp="3mpxmk7a58jws">
                An employee asks a question. Synthia identifies the obligations behind it and selects the relevant
                instructions from your library &mdash; drawing on company expertise, regulatory requirements, and
                industry guidance.
              </p>
              <p className="sub" data-id="element-476" data-mp="33uhc4c2wm2qp">
                Binding requirements go first, ahead of supporting information. The model receives a prepared request.
                A receipt records which instructions and versions were included.
              </p>
              <div className="ctas" data-id="element-477" data-mp="2u19wzzid38df">
                <a className="btn g" href="#process" data-id="element-478" data-mp="2q2u6hln2nhv9">
                  See the process &darr;
                </a>
                <Link className="btn" style={{
                background: 'transparent',
                color: 'var(--ink)',
                border: '1px solid var(--line-2)'
              }} to="/contact" data-id="element-479" data-mp="2l1mwrh1dc8ly">
                  Talk to us &rarr;
                </Link>
              </div>
            </div>
          </div>
          <div className="col-r" data-id="element-480" data-mp="10n08aqx21b0k">
            <SeeIt showLink={false} variant="finance" data-id="element-481" data-mp="15k9w624spema" />
          </div>
        </div>
      </header>

      <div className="stoprow" id="process" style={{
      display: 'block'
    }} data-id="element-482" data-mp="19lbveiyppqo9">
        <span className="clabel" style={{
        display: 'inline-flex',
        marginBottom: 18
      }} data-id="element-483" data-mp="19j99aa0okhot">
          The engines
        </span>
        <h2 style={{
        maxWidth: '36ch'
      }} data-id="element-484" data-mp="hu60cgxumj5u">
          Harvest the rules. Seat the musts.
          <br data-id="element-485" data-mp="lw14dt75zanb" />
          <span className="g" data-id="element-486" data-mp="lvhik1ee8240">Ship the receipt.</span>
        </h2>
      </div>

      <div className="grid3" data-id="element-487" data-mp="qmpsqznjrri8">
        {ENGINES.map(e => <div className="cell" key={e.n} data-id="element-488" data-mp="qoanoqdrxcgm">
            <div className="lab" data-id="element-489" data-mp="3qahcbq70q4tr">
              <span data-id="element-490" data-mp="3q966lku0in00">{e.stage}</span>
              <span className="n" data-id="element-491" data-mp="3q84wpjoqg6jv">{e.n}</span>
            </div>
            <h3 data-id="element-492" data-mp="3uarkn9ia97bs">{e.title}</h3>
            <p data-id="element-493" data-mp="3u9q62v2262pb">{e.body}</p>
          </div>)}
      </div>

      <div className="split" data-id="element-494" data-mp="3b895q64mr7nc">
        <div className="sp-l" data-id="element-495" data-mp="3b7haiwey3bxl">
          <span className="clabel" data-id="element-496" data-mp="368d2wa7o5m9d">Instruction data</span>
          <h2 data-id="element-497" data-mp="369o3k15tidw9">
            Knowledge describes. <span className="g" data-id="element-498" data-mp="3kx0uy6ib3duk">Instructions bind.</span>
          </h2>
          <p className="lede" data-id="element-499" data-mp="3kyc1ge34yzpd">
            Your stack has a shelf for every kind of knowledge — warehouses, lakes, vector stores. It has no shelf for
            the rules. So they get pasted into prompts and retrieved only when they happen to{' '}
            <strong data-id="element-500" data-mp="3ozdzirlbh5pr">resemble the question</strong>.
          </p>
          <p className="lede" style={{
          marginTop: 14
        }} data-id="element-501" data-mp="3p0ysicrzggli">
            A rule doesn't get retrieved because it's binding. It gets retrieved because it sounds like the query.{' '}
            <strong data-id="element-502" data-mp="2s5xnz9lvgyh">Facts get picked; rules get triggered</strong> — and that needs its own asset class: binary
            DO/DON'T atoms with an owner, a version, and a trigger.
          </p>
          <p className="kicker" data-id="element-503" data-mp="24kc1x487dc2n">
            Resemblance is a probability.
            <br data-id="element-504" data-mp="k1rsdmxr3cuq" />
            An obligation is not.
          </p>
        </div>
        <div className="sp-r" data-id="element-505" data-mp="p0bepog9aqnm">
          <ChunkVsAtom data-id="element-506" data-mp="oyi8295n86fm" />
        </div>
      </div>

      <div className="split" data-id="element-507" data-mp="aax3eat4dz5l">
        <div className="sp-l" data-id="element-508" data-mp="abox1g35pmt8">
          <span className="clabel" data-id="element-509" data-mp="aand0m45xpzd">The constitutional tier</span>
          <h2 style={{
          maxWidth: 'none',
          fontSize: 'clamp(24px,2.7vw,34px)'
        }} data-id="element-510" data-mp="f98gqvimirsk">
            A prompt doesn&rsquo;t get
            <br data-id="element-511" data-mp="19fnasfppxgw" />
            <span className="g" data-id="element-512" data-mp="18xopp5kv75t">to waive your obligations.</span>
          </h2>
          <p className="lede" data-id="element-513" data-mp="5clx2a21a6s4">
            Whether a request comes from an employee or an agent, some obligations apply regardless of what it asks.
            Task instructions match the work. Standing guidance carries your organization&rsquo;s voice and
            preferences. Constitutional instructions carry the privacy, regulatory, and safety requirements bound to
            your deployment. They must be included on every pass &mdash; even when a request asks to ignore them.
          </p>
          <p className="lede" style={{
          marginTop: 14
        }} data-id="element-514" data-mp="1p9kw3pek8ijr">
            Synthia checks their presence before each model call. A signed receipt records the instructions and
            versions included. Detected attempts to override them are logged for review.
          </p>
          <p className="kicker" data-id="element-515" data-mp="1abiqzarvrp0e">
            If the required instructions can&rsquo;t be included,
            <br data-id="element-516" data-mp="27yr7ssgxs9w2" />
            the request doesn&rsquo;t run.
          </p>
        </div>
        <div className="sp-r" data-id="element-517" data-mp="22yv28oslcaee">
          <ConstitutionalFlow data-id="element-518" data-mp="230plzzs4lwgw" />
        </div>
      </div>

      <div className="split" data-id="element-519" data-mp="1y8eo12gy4kqz">
        <div className="sp-l" data-id="element-520" data-mp="1y7mstsr9gp18">
          <span className="clabel" data-id="element-521" data-mp="1y6v491w2zrkg">The cost</span>
          <h2 style={{
          maxWidth: '26ch'
        }} data-id="element-522" data-mp="1ta4pqizxd415">
            The most expensive token
            <br data-id="element-523" data-mp="2qopdx316bsx2" />
            <span className="g" data-id="element-524" data-mp="2qp8wmlynelc5">is the correction.</span>
          </h2>
          <p className="lede" data-id="element-525" data-mp="2ly8zpgpj439n">
            A missed fact costs a follow-up question. A missed obligation costs a rework loop, a compliance review, a
            customer apology — every downstream token spent undoing the first pass.
          </p>
          <p className="lede" style={{
          marginTop: 14
        }} data-id="element-526" data-mp="2y99qouz7qxcp">
            Retrieval degrades gracefully; obligation doesn't. A missing disclosure doesn't{' '}
            <strong data-id="element-527" data-mp="386o74ul4zm50">partially comply</strong> — it's absent, and the absence is the incident.
          </p>
          <p className="kicker" data-id="element-528" data-mp="3d60qv6gpod3d">
            The loop buys fidelity by the token.
            <br data-id="element-529" data-mp="3d3y1mondunzp" />
            The seat buys it once.
          </p>
        </div>
        <div className="sp-r" data-id="element-530" data-mp="3h5j9twoz2e3k">
          <ReworkChart data-id="element-531" data-mp="3lychasbts0jc" />
        </div>
      </div>

      <div className="split" data-id="element-532" data-mp="3lyma0no98lsq">
        <div className="sp-l" data-id="element-533" data-mp="3m0f6xb92frnj">
          <span className="clabel" data-id="element-534" data-mp="3qxp277j4yxja">The receipt</span>
          <h2 data-id="element-535" data-mp="3qz9xx0h6smiq">
            You can't reconstruct a decision <span className="g" data-id="element-536" data-mp="3vx1onr63i2lc">you never governed.</span>
          </h2>
          <p className="lede" data-id="element-537" data-mp="4pyzf59ti6dr">
            When the auditor asks why the model said what it said, "we retrieved some relevant passages" is not an
            answer. It isn't even a defense.
          </p>
          <p className="lede" style={{
          marginTop: 14
        }} data-id="element-538" data-mp="l23103y2tgbh">
            A receipt is an answer: <strong data-id="element-539" data-mp="l45nie00srbg">obligations fired, versions seated, trigger matched, timestamp signed</strong>
            . Every request ships with its proof — before anyone asks for it.
          </p>
          <p className="kicker" data-id="element-540" data-mp="u0enpuvtntyn">
            Logging records what happened.
            <br data-id="element-541" data-mp="6dgad630124y" />
            A receipt emits proof that what&rsquo;s required rode.
          </p>
        </div>
        <div className="sp-r" data-id="element-542" data-mp="2d66byyrolsq">
          <ReceiptCard data-id="element-543" data-mp="g2q3mp9kwqun" />
        </div>
      </div>

      <div className="split" data-id="element-544" data-mp="g3hz8036eokx">
        <div className="sp-l" data-id="element-545" data-mp="g4szhpxexe7a">
          <span className="clabel" data-id="element-546" data-mp="bbhtts4c73gy">No one between the steps</span>
          <h2 data-id="element-547" data-mp="b9x1m95hvwm9">
            Chat forgives.
            <br data-id="element-548" data-mp="3jr1jkh5su3r9" />
            <span className="g" data-id="element-549" data-mp="3jqiazr21grpw">Agents commit.</span>
          </h2>
          <p className="lede" data-id="element-550" data-mp="3et9rnn55mhn2">
            In chat, the safety net is a human skimming on a deadline. The prompt carries only what someone thought to
            type, retrieval only fetches what was written down, and review catches the typo but misses the disclosure.
          </p>
          <p className="lede" style={{
          marginTop: 14
        }} data-id="element-551" data-mp="1l9zqlech5e78">
            An agent chain removes even that net. Step three's silent omission is step seven's{' '}
            <strong data-id="element-552" data-mp="1q9m13g0x4gcc">committed transaction</strong>, and there was no one between the steps to catch it.
          </p>
          <p className="lede" style={{
          marginTop: 14
        }} data-id="element-553" data-mp="2dwkfm85h9e7m">
            The obligations have to ride <strong data-id="element-554" data-mp="2hzqlvfslb5e3">inside the payload</strong> — every step, a receipt at every hop.
            Agent governance that lives anywhere else arrives after the commit.
          </p>
        </div>
        <div className="sp-r" data-id="element-555" data-mp="28y0s43b8jud5">
          <AgentChain data-id="element-556" data-mp="291ev9drq47ln" />
        </div>
      </div>

      <div className="stoprow" data-id="element-557" data-mp="skam2r0k2w0v">
        <h2 style={{
        maxWidth: 'none'
      }} data-id="element-558" data-mp="sk0vb17osku4">FAQs: How</h2>
      </div>

      <Faq items={faqsHow} data-id="element-559" data-mp="xlgesou7ujae" />

      <CtaBand data-id="element-560" data-mp="xlq92omanclw" />
      <Ledger data-id="element-561" data-mp="xi2ern90ym64" />
    </>;
}